{
  "version": 1,
  "asset_id": "bc79ae8f-79c1-4b85-9ec4-83773d1ccba5",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/bc79ae8f-79c1-4b85-9ec4-83773d1ccba5/group-nights-parallax.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/bc79ae8f-79c1-4b85-9ec4-83773d1ccba5/group-nights-parallax.webp",
  "original_filename": "group-nights-parallax.webp",
  "size": 186158,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:12:48Z"
}
